import AppointmentList from "./AppointmentList";

/**
 * This class is used for the routing of future and history appointments
 */
export default class Appointments {

    // constructor
    constructor(selector) {
        this.$plugin = $(selector);
        let vm = this;
        let $plugin = this.$plugin;
        if ($plugin.length === 0) {
            return false;
        }

        this.appointmentListFuture = null;
        this.appointmentListHistory = null;

        // check router event
        window.addEventListener("router", function (e) {

            // routing switch
            switch (e.detail.path) {
                case '#!/0':
                    vm.futureList();
                    break;
                case '#!/1':
                    vm.historyList();
                    break;
            }
        });

    }

    futureList() {
        if (this.appointmentListFuture instanceof AppointmentList === false) {
            this.appointmentListFuture = new AppointmentList('[data-tncp-plugin="AppointmentListFuture"]');
        }
    }

    historyList() {
        if (this.appointmentListHistory instanceof AppointmentList === false) {
            this.appointmentListHistory = new AppointmentList('[data-tncp-plugin="AppointmentListHistory"]');
        }
    }

}